import React, { useEffect, useState } from "react";
import axios from "axios";

const SchoolAchievement = () => {
  const [achievements, setAchievements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const currentSessionId = localStorage.getItem("currentSessionId"); // Current session

  useEffect(() => {
   const fetchAchievements = async () => {
  try {
    const sessionId = localStorage.getItem("currentSessionId"); // get current session
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/api/achievements/getSchoolAchievementsBySession/${sessionId}`
    );
    setAchievements(response.data);
  } catch (err) {
    console.error("Error fetching achievements: ", err);
    setError("Failed to fetch achievements");
  } finally {
    setLoading(false);
  }
};


    fetchAchievements();
  }, [currentSessionId]);

  if (loading)
    return (
      <div className="text-center p-8 text-gray-700 text-sm sm:text-base">
        Loading... <i className="fas fa-spinner fa-spin text-lg"></i>
      </div>
    );

  if (error)
    return (
      <div className="text-center p-8 text-red-500 text-sm sm:text-base">
        {error}
      </div>
    );

  return (
    <div className="container mx-auto p-2 sm:p-6 lg:p-8">
      <h1 className="text-[18px] font-semibold mb-6 text-center text-gray-800">
        <i className="fas fa-award text-red-500 mr-2"></i>
        School Achievements
      </h1>

      {achievements.length === 0 ? (
        <div className="text-center text-[14px] mt-4 text-gray-500">
          <i className="fas fa-exclamation-circle text-red-500 mr-2"></i>
          No achievements found for this session.
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {achievements.map((achievement) => (
            <div
              key={achievement._id}
              className="bg-white p-2 sm:p-4 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
            >
              <h2 className="text-sm sm:text-lg font-semibold mb-1">
                {achievement.competitionTitle}
              </h2>

              <p className="text-gray-600 text-sm sm:text-base mb-1">
                <i className="far fa-calendar-alt text-blue-500 mr-1"></i>
                {new Date(achievement.date).toLocaleDateString()}
              </p>

              <p className="text-gray-700 mb-1 text-sm sm:text-base">
                <strong>Place:</strong> {achievement.place}
              </p>

              <p className="text-gray-700 mb-1 text-sm sm:text-base">
                <strong>School Rank:</strong> {achievement.schoolRank}
              </p>

              <p className="text-gray-700 mb-2 text-sm sm:text-base">
                <strong>Description:</strong> {achievement.description}
              </p>

              {achievement.image && (
                <a
                  href={achievement.image}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:underline flex items-center text-sm sm:text-base"
                >
                  <i className="fas fa-eye mr-2"></i>View
                </a>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SchoolAchievement;
